module.exports = __webpack_public_path__ + "img/diannao.775b3be7.png";